<template>
  <div class="vraag">
    <div class="vraag-tekst">{{vraag}}</div>
    <div class="vraag-image"><img :src="'/images/VraagImg/' + image" alt="Afbeelding bij vraag" v-show="image && image != ''" /><img :src="dbimage" alt="Afbeelding bij vraag" v-show="dbimage" /></div>
    <div class="btn-toelichting-area">
      <div class="hardware-button button1-janee" v-if="antwoordtype=='janee'">Nee</div>
      <div class="hardware-button button2-janee" v-if="antwoordtype=='janee'"></div>
      <div class="hardware-button button3-janee" v-if="antwoordtype=='janee'">Ja</div>      

      <div class="hardware-button button1-smiley" v-if="antwoordtype=='smiley'"><img src="/images/sad-black.png"/></div>
      <div class="hardware-button button2-smiley" v-if="antwoordtype=='smiley'"><img src="/images/neutral-black.png"/></div>
      <div class="hardware-button button3-smiley" v-if="antwoordtype=='smiley'"><img src="/images/happy-black.png"/></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Vraag',
  props: ['vraag','image', 'antwoordtype','audio','autonext','vraagid','userid','vraagaanwezig','afbeeldingcode'],
  data() { 
    return {
        timer: null,
        ConsoleNaam: 'Prototype-001',
        dbimage: null,
    }
  },
  methods: {
    /*
    ja: function() {
      this.$emit('antwoord', 'ja');
    },
    nee: function() {
      this.$emit('antwoord', 'nee');
    },
    s1: function() {
      this.$emit('antwoord', 's1');
    },
    s2: function() {
      this.$emit('antwoord', 's2');
    },
    s3: function() {
      this.$emit('antwoord', 's3');
    },
    s4: function() {
      this.$emit('antwoord', 's4');
    },
    volume: function() {
      alert('Hiermee kun je het geluid harder of zachter zetten.');
    },
    wablieft: function() {
      this.spreekvraag();
    },
    */
    slaover: function() {
      this.$emit('antwoord', 'slaover');
    },
    spreekvraag: function() {
      if (this.audio && this.audio != '')
      {
          var audio = new Audio('/audio/'+this.audio);
          audio.play();
      }
    },
    pollNext: function() {
      // Vraag aan server of we naar volgende vraag moeten (is er een hardware-button ingedrukt?)
      this.$api.pAntwoordPoll({ConsoleNaam: this.ConsoleNaam, VraagId: this.vraagid, UserId: this.userid})
        .then((response) => {
          if (response.data.length > 0)
          {
            if (response.data[0].Next) // Naar volgende vraag als Next == true
              this.$emit('antwoord', 'next');
            if (response.data[0].Herhaal) // Spreek vraag opnieuw uit als Herhaal == true
              this.spreekvraag();
            if (response.data[0].StopSessie && this.vraagaanwezig == true) // Einde vragensessie => naar wachtscherm.
              window.location = "/wacht";
          }
        });
    }

  },
  watch: {
    vraag: function() {
      // Spreek vraag uit bij verandering van vraag.
      this.spreekvraag(); 
    },
    autonext: function() {
      // Automatisch naar volgende vraag na X seconde.
      if (this.timer)
      {
        window.clearTimeout(this.timer);
        this.timer = null;
      }
      if (this.autonext)
      {
        var self = this;
        this.timer = setTimeout(function() {self.slaover();}, this.autonext * 1000);
      }
    },
    afbeeldingcode: function () {
      if (this.afbeeldingcode) {
        this.dbimage = null;
        this.$api
          .pMedewerkerFotoGet({ Code: this.afbeeldingcode })
          .then((response) => {
            if (response.data.length > 0) this.dbimage = response.data[0].Foto;
          });
      } else {
        this.dbimage = null;
      }
    },
  },
  created: function() {
    var self = this;
    // Timer voor uitspreken 1e vraag.
    setTimeout(function() {self.spreekvraag();}, 2000);
    
    // Timer voor polling-mechanisme voor beantwoorden via hardware-buttons.
    setInterval(function() {self.pollNext();}, 1000);
  }


}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.vraag {
  width: 1260px;
  height: 800px;
  overflow: hidden;
}
.vraag-tekst {
  width: 100%;
  height: 150px;
  font-size: 34pt;
  display:flex;
  justify-content:center;
  align-items:center;
}
.vraag-image {
  width: 100%;
  height: 500px;
  display:flex;
  justify-content:center;
  align-items:center;
}
.vraag-image>img {
  height: 100%;
}

.btn-toelichting-area {
  width: 100%;
  height: 150px;
  display: flex;
  justify-content:center;
  align-items:flex-end;
  padding-left: 3px; /* Hiermee rode/gele/groene vlakken uitlijnen met hardware-buttons. */
}

.hardware-button {
  width: 200px;
  height: 140px;
  display:flex;
  justify-content:center;
  align-items:center;
  margin-left: 107px;
  margin-right: 107px;
}

.hardware-button img {
  width: 100px;
  height: 100px;
}

.button1-janee {
  background-color: red;
  font-size: 34pt;
  color: white;
}

.button2-janee  {
  font-size: 34pt;
}

.button3-janee {
  background-color: green;
  font-size: 34pt;
  color: white;
}

.button1-smiley {
  background-color: red;
}

.button2-smiley {
  background-color: yellow;
}

.button3-smiley {
  background-color: green;
}

</style>
